




import { mapGetters } from "vuex";
import BaseInfoTooltip from "@/components/Base/BaseInfoTooltip.vue";

export default {
  name: "TooltipPrijs",
  props: {
    perDay: Boolean
  },
  components: { BaseInfoTooltip },
  computed: {
    ...mapGetters(["getBoolSetting"])
  },
  methods: {
    getText(): string {
      if (this.perDay) {
        return this.$t("TooltipPrijs.text_dag");
      }

      return this.$t("TooltipPrijs.text_week");
    }
  }
};
